import axios from 'axios'
import { put, call, takeLatest } from 'redux-saga/effects'

import apiConfig from '@services/apiConfig'

import {
  GET_COMPANIES,
  setCompanies,
  GET_COMPANY,
  setCompany
} from '@actions/company'
import errorHandler from '../errorHandler'

const classPrefix = '/companies'

function* getCompanies({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/paginated`,
      params,
    })
    yield put(setCompanies(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getCompany({ companyId, callback }) {
  try {
    if (companyId) {
      const response = yield call(axios, {
        method: 'GET',
        url: `${apiConfig.prefix + classPrefix}/${companyId}`,
      })
      yield put(setCompany(response.data))
      callback && callback(response.data)
    }
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

export function* getCompaniesSaga() {
  yield takeLatest(GET_COMPANIES, getCompanies)
}

export function* getCompanySaga() {
  yield takeLatest(GET_COMPANY, getCompany)
}
